import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../store/modules/ModalActions';
import { getElementID } from '../../utils/HTMLUtils';
import { Col } from '../Col';
import { CustomButton } from '../CustomButton';
import { GenericModal } from '../GenericModal';
import { Row } from '../Row';
import styles from './SingleAlertModal.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'single-alert-modal';

class SingleAlertModal extends Component {
  toClose = () => {
    new Promise((resolve, reject) => {
      if (typeof this.props.closeCallback === 'function') {
        this.props.closeCallback();
        resolve();
      } else {
        reject();
      }
    }).then(
      () => {
        this.props.closeModal(this.props.modalKey);
      },
      () => {
        this.props.closeModal(this.props.modalKey);
      }
    );
  };

  render() {
    return (
      <GenericModal
        id={rootElementId}
        onClose={this.toClose}
        DialogProps={{
          maxWidth: 'sm',
          disableBackdropClick: true,
          disableEscapeKeyDown: true,
        }}
        title={this.props.title}
        footerContent={
          <Row>
            <Col
              cols={[12, 12, 12, 12, 12]}
              className={rootClassName + '-col-button'}
            >
              <CustomButton
                id={getElementID(rootElementId, 'close')}
                theme='pufvYellow'
                className={rootClassName + '-close-buttom'}
                label={
                  this.props.closeLabel || this.props.languageValues.okButton
                }
                onClick={this.toClose}
              />
            </Col>
          </Row>
        }
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>{this.props.content}</Col>
        </Row>
      </GenericModal>
    );
  }
}

SingleAlertModal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  closeCallback: PropTypes.func,
  closeLabel: PropTypes.string,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SingleAlertModal);
